<div class="header-cls">
    <div class="header-logo header-styles">
        <img src='../../../../assets/img/volo-logo.png' class="mobile-logo">
    </div>
    <div class="header-title header-styles txt-black-header">
        <span>{{headerName}}</span>
    </div>  
    <div class="header-menu header-styles" [ngClass]=" isWavier ? 'linkCls': '' "> 
        <div *ngIf="userRoles" class="nav-user-role" [hidden]="!isLogOut">
            <div [hidden]="!isLogOut" style="margin-left: 15px;" *ngFor = "let role of userRoles">{{ role.role.name }}</div>
            <!-- <mat-form-field class="mat-date-pick"> -->
                <!-- <mat-label>State</mat-label> -->
                <!-- <input matInput formControlName="state"/> -->
                <!-- <mat-select >
                  <mat-option *ngFor="let role of userRoles" [value]="role.roleId"> {{ role.role.name }}</mat-option>
                </mat-select> -->
                <!-- <mat-error *ngIf="searchForm.get('stateId').hasError('required')">
                  Please enter state
                </mat-error> -->
              <!-- </mat-form-field> -->
            <!-- <select name="currentRole"> -->
              <!-- <option selected="selected" class="select-option">Reason</option> -->
              <!-- <option *ngFor="let role of userRoles" [value]="role.roleId">
                {{ role.role.name }}</option>
            </select> -->
          </div>  
          <div class="nav-link" [hidden]="!isAdminUrl" (click)="goOfficerUrl()">Officer</div>
          <div class="nav-link" [hidden]="!isAdminUrl" (click)="goStaffUrl()">Staff</div>
          <div class="nav-link" [hidden]="!showAdmin" (click)="goAdminUrl()">Admin</div>

          <div  title="Home" style="cursor: pointer !important;" class="nav-link" [hidden]="isLogOut" (click)="goHome()"><span class="material-icons">
            home
            </span></div>
        <!-- <div class="nav-link" [hidden]="isLogOut" (click)="goHome()">Home</div> -->
        <!-- <div class="nav-link" [hidden]="isLogOut"  (click)="gotoAdmin()">Admin</div>
        <div class="nav-link" [hidden]="isLogOut" (click)="gotoVillageStaff()">Village staff</div>
        <div class="nav-link" [hidden]="isLogOut" (click)="gotoOfficer()">Officer</div> -->
        <div class="nav-link" title="Logout" *ngIf="(!isLogOut || !iscodeEnforcement) && !hideMe" (click)="gotoLogOut()"><i class="fa fa-sign-out" aria-hidden="true"></i>
        </div>
        <!-- <div class="nav-link"><span style="padding-right: 10px;" class="txt-black">Having Trouble?</span>Get Help</div> -->
    </div>
</div>  